<mat-dialog-content>
    <!-- <mat-progress-spinner *ngIf="!showFileFailedMessage" mode="indeterminate"></mat-progress-spinner> -->
    <mat-progress-bar color="#99ff66" *ngIf="!showFileFailedMessage" mode="indeterminate"></mat-progress-bar>
    <div fxLayout="row"><pre></pre></div>
    <b>{{dailogContent}}</b>
    <div fxLayout="row"><pre></pre></div>

    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" mat-dialog-close>Ok</button>
    </mat-dialog-actions>
</mat-dialog-content>
  